import React from 'react';

export default function ReplyQuoteBlock({ sender, text, onClick, onPrimary = false }) {
  if (!text?.trim()) return null;
  const truncated = text.length > 120 ? `${text.slice(0, 117)}…` : text;
  const className = `messenger-reply-quote${onPrimary ? ' messenger-reply-quote--on-primary' : ''}`;
  return (
    <button
      type="button"
      className={className}
      onClick={onClick}
      tabIndex={onClick ? 0 : -1}
    >
      {sender ? (
        <span className="messenger-reply-quote-sender">{sender}</span>
      ) : null}
      <span className="messenger-reply-quote-text">{truncated}</span>
    </button>
  );
}
